import { Component, OnInit } from '@angular/core';
import { getFirebaseBackend } from 'src/app/authUtils';
import { ChatbotService } from 'src/app/core/services/chabot/chatbot.service';

@Component({
  selector: 'app-chat-bot',
  templateUrl: './chat-bot.component.html',
  styleUrls: ['./chat-bot.component.scss']
})
export class ChatBotComponent implements OnInit {

   private user; 
   private leads_info: any;
   public chatbotVisible: boolean = false;
   public loadChat: boolean = false;


  constructor(private chatSrv: ChatbotService) {
    this.user = getFirebaseBackend()?.getAuthenticatedUser();
  }

  ngOnInit() {
    this.getLeadsOfThisUser();
  }

  userInput: string = '';
  messages: any[] = [];

  sendMessage() {
      if (this.userInput.trim()) {
          this.messages.push({ content: this.userInput, role: 'user' });
          this.askChatGPT(this.userInput);
          this.userInput = '';
          this.loadChat = true;
          // Aquí puedes añadir la lógica para enviar el mensaje al backend o API
      }
  }

  getLeadsOfThisUser(){
    const dateStart= '';
    const dateEnd = '';
    this.chatSrv.get_user_leads(this.user.IdUser,dateStart, dateEnd).subscribe(data=>{
        this.leads_info = data;
    })
  }

  askChatGPT(message: string){
    this.chatSrv.sendMessage(this.leads_info, this.messages).subscribe(data=>{
        this.loadChat = false;
        this.messages.push({ content: data.body, role: 'assistant' });
    })
  }


  toggleChatbot() {
    this.chatbotVisible = !this.chatbotVisible;
  }

}
